import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import './Header.css';
import { NotificationContainer } from "react-notifications";
import { Trans, useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

function Header() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleNavigate = (path) => {
        navigate(path);
    };

    return (
        <>
            <Navbar bg="dark" variant="dark" expand="lg">
                <Container>
                    <Navbar.Brand href="/">
                        <img className="logo rounded" src="/logo512.png" alt="KooApp logo" /> <Trans>header.title</Trans>
                    </Navbar.Brand>
                    <Nav className="ms-auto">
                        <NavDropdown 
                            title={<FontAwesomeIcon icon={faBars} />} 
                            id="nav-dropdown"
                            align="end"
                            className="burger-menu"
                        >
                            <NavDropdown.Item onClick={() => handleNavigate('/connect')}>
                                {t('header.menu.connect')}
                            </NavDropdown.Item>
                            <NavDropdown.Item onClick={() => handleNavigate('/convert')}>
                                {t('header.menu.convertLog')}
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Container>
            </Navbar>

            <NotificationContainer />
        </>
    );
}

export default Header;
